<template>
  <layout>
    <!--城市选择区-->
    <template v-slot:pageLeft>
      <QHleftcity @change="change" @cityLoading="cityLoading" ref="QHleftcity"></QHleftcity>
    </template>
    <!--城市选择区 end-->

    <!--总统计区-->
    <template v-slot:pageTab>
      <div class="headerA flex-center">
        <div class="flex-center-col">
          <font class="fontColor">排放统计</font>
          <span>排放联单</span>
        </div>
      </div>
      <div class="headerB flex-between" v-if="dataLoading">
        <div class="flex-center-y">
          <dl class="item">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">
                <p>{{ dataName }}</p>
                <p>联单量</p>
              </div>
            </dt>
          </dl>
          <dl class="item">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">
                <div class="danwei">联<br />单</div>
              </div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(total.thisCountDan || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">联</div>
            </dt>
          </dl>
          <dl class="item">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">排<br />放</div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(total.thisCountLifang || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">m³</div>
            </dt>
          </dl>
        </div>
      </div>
    </template>
    <!--总统计区 end-->

    <!--搜索及功能区-->
    <template v-slot:pageSearch>
      <ul class="tab">
        <li style="width: 220px">
          <Input size="small" v-model="searchMap.keywordA" placeholder="请输入关键词">
            <Select v-model="searchMap.likeNameA" slot="prepend" style="width: 90px">
              <Option value="">查询全部</Option>
               <Option value="projectName">排放项目</Option>
              <Option value="projectOrgName">排放单位</Option>
              <Option value="cityteamName">运营单位</Option>
              <Option value="orgNameYunshu">运输单位</Option>
              <Option value="NO">联单编号</Option>
              <Option value="orgNameJieshou">接收单位</Option>
              <Option value="driverName">清运司机</Option>
              <Option value="licensePlate">车牌号码</Option>
              <Option value="garbageTypeName">垃圾类型</Option>
              <Option value="qingYunStartDistrictName">装车区县</Option>
              <Option value="qingYunStartStreetName">装车街道</Option>
              <Option value="qingYunEndDistrictName">卸车区县</Option>
              <Option value="qingYunEndStreetName">卸车街道</Option>
            </Select>
          </Input>
        </li>
        <li style="width: 220px">
          <Input size="small" v-model="searchMap.keywordB" placeholder="请输入关键词">
            <Select v-model="searchMap.likeNameB" slot="prepend" style="width: 90px">
              <Option value="">查询全部</Option>
              <Option value="orgNameYunshu">运输单位</Option>
              <Option value="cityteamName">运营单位</Option>
               <Option value="projectName">排放项目</Option>
              <Option value="projectOrgName">排放单位</Option>
              <Option value="NO">联单编号</Option>
              <Option value="orgNameJieshou">接收单位</Option>
              <Option value="driverName">清运司机</Option>
              <Option value="licensePlate">车牌号码</Option>
              <Option value="garbageTypeName">垃圾类型</Option>
              <Option value="qingYunStartDistrictName">装车区县</Option>
              <Option value="qingYunStartStreetName">装车街道</Option>
              <Option value="qingYunEndDistrictName">卸车区县</Option>
              <Option value="qingYunEndStreetName">卸车街道</Option>
            </Select>
          </Input>
        </li>
        <li style="width: 90px">
          <Select v-model="searchMap.garbageType" placeholder="垃圾类型">
            <Option value="1">装修垃圾</Option>
            <Option value="2">建筑垃圾</Option>
          </Select>
        </li>
        <li style="width: 90px">
          <Select v-model="searchMap.garbageName" placeholder="垃圾名称">
            <Option value="工程渣土">工程渣土</Option>
            <Option value="拆除垃圾">拆除垃圾</Option>
            <Option value="工程垃圾">工程垃圾</Option>
            <Option value="工程泥浆">工程泥浆</Option>
            <Option value="装修垃圾">装修垃圾</Option>
          </Select>
        </li>
        <li style="width: 90px">
          <Select v-model="searchMap.status" placeholder="清运状态">
            <Option value="100">正在出场</Option>
            <Option value="200">正在行车</Option>
            <Option value="300">正在接收</Option>
            <Option value="400">完成清运</Option>
          </Select>
        </li>
        <li style="width: 90px">
          <Select v-model="searchMap.examinePaifangOrg" placeholder="排放意见">
            <Option :value="100">排放待审</Option>
            <Option :value="200">排放同意</Option>
            <Option :value="300">排放拒绝</Option>
          </Select>
        </li>
        <li style="width: 90px">
          <Select v-model="searchMap.examineJieshouOrg" placeholder="接收意见">
            <Option :value="100">接收待审</Option>
            <Option :value="200">接收同意</Option>
            <Option :value="300">接收拒绝</Option>
          </Select>
        </li>
        <li style="width: 90px">
          <Select v-model="searchMap.yichangType" placeholder="异常状态">
            <Option value="">异常状态</Option>
            <Option :value="100">排放异常</Option>
            <Option :value="200">接收异常</Option>
            <Option :value="300">运输异常</Option>
            <Option :value="500">异常联单</Option>
            <Option :value="400">平台已核</Option>
          </Select>
        </li>
        <li style="width: 90px">
          <Select v-model="searchMap.projectType" placeholder="来源">
            <Option value="">全部</Option>
            <Option :value="100">工地运</Option>
            <Option :value="200">整车运</Option>
            <Option :value="300">零散运</Option>
            <Option :value="400">堆放运</Option>
            <Option :value="500">水运单</Option>
            <Option :value="600">车厢运</Option>
          </Select>
        </li>
        <li style="width: 90px">
          <Select v-model="searchMap.projectForm" placeholder="运输类型">
            <Option value="">全部</Option>
            <Option :value="100">小三轮</Option>
            <Option :value="200">自卸车</Option>
            <Option :value="300">收集箱</Option>
            <Option :value="400">船运类</Option>
          </Select>
        </li>
        <li style="width: 90px">
          <Select v-model="searchMap.orgKind" placeholder="排放角色">
            <Option value="">全部</Option>100 工程项目
            <Option :value="100">工程项目</Option>
            <Option :value="200">临时中转点</Option>
            <Option :value="300">移动收集箱</Option>
            <Option :value="400">物业单位</Option>
            <Option :value="500">居民</Option>
            <Option :value="600">其他</Option>
            <Option :value="700">分拣中心</Option>
            <Option :value="800">资源利用企业</Option>
            <Option :value="900">消纳场</Option>
            <Option :value="1000">水路中转</Option>
            <Option :value="1100">市区转移</Option>
          </Select>
        </li>
        <li style="width: 210px">
          <QHdatePicker v-model="searchMap.daterange" type="daterange" placeholder="清运时间"></QHdatePicker>
        </li>
        <li>
          <Button type="primary" @click="search" size="small" icon="ios-search">查询</Button>
        </li>
        <li>
          <Button type="primary" @click="uploadExcel" size="small" >导出联单</Button>
        </li>
      </ul>
    </template>
    <!--搜索及功能区 end-->

    <!--主体呈现区-->
    <template v-slot:pageContent>
      <QHTable :total="total['pageCount'] || 0" :pageThis="pageThis">
        <Table :columns="columns" :data="list" @on-selection-change="(event) => $tableSeletChange(event, pageThis)" :loading="loading" class="QHTableList">
          <!--分割区-->
          <template slot-scope="{ row }" slot="carNumber">
            <span>{{ row.carNumber }}车</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="garbageNumber">
            <span>{{ row.garbageNumber }}m³</span>
          </template>

                  <!--分割区-->
          <template slot-scope="{ row }" slot="projectType">
            <span v-if="row.projectType == 100">工地单</span>
            <span v-if="row.projectType == 200">整车单</span>
            <span v-if="row.projectType == 300">零散单</span>
            <span v-if="row.projectType == 400">堆放单</span>
            <span v-if="row.projectType == 500">水运单</span>
            <span v-if="row.projectType == 600">车厢单</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="emissionTime">
            <span class="oe1">{{ $timeFmt(row.emissionTime, "YYYY-MM-DD") }}</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="dianziweilanStatus">
            <span class="CL2 iconfont icon-wenhao-quan" v-if="row.dianziweilanStatus == 100"></span>
            <span class="CL5 iconfont icon-tongyi" v-if="row.dianziweilanStatus == 300"></span>
            <span class="CL1 iconfont icon-jujue" v-if="row.dianziweilanStatus == 200"></span>
          </template>
          <!--分割区-->
          <template slot-scope="{ row }" slot="status">
            <Tag color="red" v-if="row.status == 100">{{ $state["electronicbill"][row.status] }}</Tag>
            <Tag color="blue" v-if="row.status == 200">{{ $state["electronicbill"][row.status] }}</Tag>
            <Tag color="cyan" v-if="row.status == 300">{{ $state["electronicbill"][row.status] }}</Tag>
            <Tag color="cyan" v-if="row.status == 400">{{ $state["electronicbill"][row.status] }}</Tag>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="examinePaifangOrg">
            <span class="CL2 iconfont icon-wenhao-quan" v-if="row.examinePaifangOrg == 100">
              <font class="ML3">待审</font>
              <font class="ML3">(排放方待审)</font>
            </span>
            <span class="CL5 iconfont icon-jujue" v-if="row.examinePaifangOrg == 300">
              <font class="ML3">异常</font>
              <font class="ML3 CL4" v-if="row.statusPaifangOrg == 300">(平台方核拒)</font>
              <font class="ML3" v-else>(排放方拒绝)</font>
            </span>
            <span class="CL4 iconfont icon-tongyi" v-if="row.examinePaifangOrg == 200">
              <font class="ML3">正常</font>
              <font class="ML3 CL5" v-if="row.statusPaifangOrg == 200">(平台方核准)</font>
              <font class="ML3" v-else>(排放方同意)</font>
            </span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="examineJieshouOrg">
            <span class="CL2 iconfont icon-wenhao-quan" v-if="row.examineJieshouOrg == 100">
              <font class="ML3">待审</font>
              <font class="ML3">(接收方待审)</font>
            </span>
            <span class="CL5 iconfont icon-jujue" v-if="row.examineJieshouOrg == 300">
              <font class="ML3">异常</font>
              <font class="ML3 CL4" v-if="row.statusJieshouOrg == 300">(平台方核拒)</font>
              <font class="ML3" v-else>(接收方拒绝)</font>
            </span>
            <span class="CL4 iconfont icon-tongyi" v-if="row.examineJieshouOrg == 200">
              <font class="ML3">正常</font>
              <font class="ML3 CL5" v-if="row.statusJieshouOrg == 200">(平台方核准)</font>
              <font class="ML3" v-else>(接收方同意)</font>
            </span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="yunshuYichang">
            <span class="CL5 iconfont icon-jujue" v-if="row.status < 400 && $isYunshuChaoshi(row.emissionTime)">
              <font class="ML3">运输超时</font>
              <font class="ML3">(系统预警)</font>
            </span>
            <span class="CL5 iconfont icon-jujue" v-else-if="row.examineJieshouOrg == 300 && $isblank(row.orgIdJieshou) && row.status > 200">
              <font class="ML3">卸点异常</font>
              <font class="ML3">(系统预警)</font>
            </span>
            <span class="CL2 iconfont icon-wenhao-quan" v-else-if="row.status < 300">
              <font class="ML3">等待审核</font>
              <font class="ML3">(系统提示)</font>
            </span>
            <span class="CL4 iconfont icon-tongyi" v-else>
              <font class="ML3">运输正常</font>
              <font class="ML3">(系统判定)</font>
            </span>
          </template>
          
          <!--分割区-->
          <template slot-scope="{ row }" slot="action">
            <div class="flex-center">
              <Button type="warning" size="small" @click="$refs.detailed.hiPop(row)" style="margin-left: 5px">详情</Button>
            </div>
          </template>
        </Table>
      </QHTable>
    </template>
    <!--主体呈现区 end-->

    <!--弹窗组件区-->
    <template v-slot:pageBlock>
      <!--联单详情-->
      <detailed ref="detailed"></detailed>
    </template>
    <!--弹窗组件区 end-->
  </layout>
</template>
<script>
import detailed from "./block/detailed/detailed";
export default {
  components: {
    detailed,
  },
  data() {
    return {
      //列表配置项(loading加载效果,columns列,list数据,selectedRows选中,total统计项)@@@@@@@@@@@
      list: [],
      loading: false,
      pageThis: this,
      selectedRows: [],
      total: {},
      columns: this.$colFilter([
        {
          title: "联单编号",
          key: "NO",
          width: 140,
          align: "center",
          ellipsis: true,
          tooltip: true,
        },
        {
          title: "排放合规",
          key: "examinePaifangOrg",
          width: 160,
          align: "center",
          slot: "examinePaifangOrg",
        },
        {
          title: "接收合规",
          key: "examineJieshouOrg",
          width: 160,
          align: "center",
          slot: "examineJieshouOrg",
        },
        {
          title: "运输合规",
          key: "yunshuYichang",
          width: 160,
          align: "center",
          slot: "yunshuYichang",
        },
        {
          title: "排放项目",
          key: "projectName",
          minWidth: 200,
          align: "left",
          sortable: true,
          ellipsis: true,
          tooltip: true,
        },
        {
          title: "排放单位",
          key: "orgPaifang_name",
          minWidth: 100,
          align: "left",
          sortable: true,
          ellipsis: true,
          tooltip: true,
        },
        {
          title: "来源",
          key: "projectType",
          width: 60,
          align: "center",
          slot: "projectType",
        },
         {
          title: "排放垃圾",
          key: "garbageTypeName",
          width: 150,
          align: "center",
          render: (h, parameter) => {
            var row = parameter.row;
            var html1 = row.garbageName;
           
            return h("span", html1);
          },
        },
        {
          title: "排放数量",
          key: "garbageNumber",
          width: 100,
          align: "center",
          slot: "garbageNumber",
        },
        {
          title: "车数",
          key: "carNumber",
          width: 60,
          align: "center",
          slot: "carNumber",
        },
        {
          title: "区县",
          key: "qingYunStartDistrictName",
          width: 110,
          align: "center",
        },
        {
          title: "街道",
          key: "qingYunStartStreetName",
          width: 120,
          align: "center",
        },
        {
          title: "清运时间",
          key: "emissionTime",
          width: 130,
          align: "center",
          slot: "emissionTime",
        },
        {
          title: "清运区域",
          key: "qingYunStartDistrictName",
          width: 80,
          align: "center",
        },
        {
          title: "清运司机",
          key: "driverName",
          width: 90,
          align: "center",
        },
        {
          title: "清运车牌",
          key: "licensePlate",
          width: 100,
          align: "center",
        },
        {
          title: "清运车型",
          key: "carName",
          width: 140,
          align: "center",
        },
        {
          title: "运输单位",
          key: "orgNameYunshu",
          width: 160,
          align: "center",
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "接收单位",
          key: "orgNameJieshou",
          width: 140,
          align: "center",
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "清运状态",
          key: "status",
          width: 80,
          align: "center",
          slot: "status",
          fixed: "right",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          width: 80,
          slot: "action",
          align: "center",
        },
      ]),
      //搜索配置项(searchMap)@@@@@@@@@@@@@@@@@@@@@@@
      searchMap: {
        likeNameA: "",
        likeNameB: "",
        keywordA: "",
        keywordB: "",
        pageNo: 1,
        projectType:"",
        pageSize: 25,
        daterange: "",
        searchType: 100,
        code: "",
        level: "",
      },
      //其他逻辑配置项@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
      dataLoading: false,
      dataName: "",
    };
  },

  // +----------------------------------------------------------------------
  // | mounted
  // +----------------------------------------------------------------------
  mounted() {
    var year = this.$getUrlParams("year");
    this.searchMap.daterange = this.$yeaerStartEnd(year);
    this.$refs.QHleftcity.int();
  },

  methods: {
    // +----------------------------------------------------------------------
    // | 切换数据地址数据
    // +----------------------------------------------------------------------
    change(res) {
      this.searchMap.code = res.code;
      this.searchMap.level = res.level;
      this.dataName = res.name;
      this.dataLoading = false;
    },

    cityLoading(res) {
      this.searchMap.code = res.code;
      this.searchMap.level = res.level;
      this.getList();
    },

    // +----------------------------------------------------------------------
    // | 列表
    // +----------------------------------------------------------------------
    getList() {
      var that = this;
      var https = {
        type: "isPagelist",
        api: this.$api.getElectronicbillList,
        parameter: this.searchMap,
      };
      this.$httpsApi(https, function () {
        that.dataLoading = true;
      });
    },
          // +----------------------------------------------------------------------
        // | 导出excel
        // +----------------------------------------------------------------------
        uploadExcel() {
            this.$loading(true);
            this.searchMap.ids = this.selectedRows;
            var obj1 = this.searchTemp;
            var obj2 = this.searchMap;
        
            this.searchMap = { ...obj2, ...obj1 };
            
            var parameter = this.searchMap;
            var url = "/zxbigscreen/Electronicbill/uploadExcel";
            var fileName = "工地联单.xlsx";
            this.$downLoad(url,parameter,fileName);
            this.$loading(false);
        },

    // +----------------------------------------------------------------------
    // | 搜索
    // +----------------------------------------------------------------------
    search() {
      this.getList();
    },
  },
};
</script>
